module.exports = {
      id: "pen-usage",
      viewBox: "0 0 20 20",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#pen",
      toString: function () {
        return this.url;
      }
    }